import { lazyLoadContentComponent, loadBundle } from '../../services/LazyLoadComponent';
import propTypes from './propTypes';

const ActivityStreamLazy = lazyLoadContentComponent(() =>
    import(/* webpackChunkName: 'ActivityStream' */ './').then(loadBundle)
);
ActivityStreamLazy.propTypes = propTypes;
export default ActivityStreamLazy;
